import { API_URLS } from '../config/api';

// Analytics tracking utility
class Analytics {
  constructor() {
    this.sessionId = this.getOrCreateSessionId();
    this.isTracking = false;
  }

  getOrCreateSessionId() {
    let sessionId = localStorage.getItem('analytics_session_id');
    if (!sessionId) {
      sessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('analytics_session_id', sessionId);
    }
    return sessionId;
  }

  async trackPageView(pageUrl = window.location.href, pageTitle = document.title) {
    if (this.isTracking) return;
    
    this.isTracking = true;
    
    try {
      const response = await fetch(API_URLS.ADMIN.TRACK_VISIT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          session_id: this.sessionId,
          page_url: pageUrl,
          page_title: pageTitle
        })
      });

      if (response.ok) {
        // Page view tracked
      }
    } catch (error) {
      // Silently handle analytics error
    } finally {
      this.isTracking = false;
    }
  }

  // Track page view on page load
  init() {
    // Track initial page view
    this.trackPageView();

    // Track page views on route changes (for SPA)
    if (typeof window !== 'undefined') {
      // Listen for popstate events (back/forward navigation)
      window.addEventListener('popstate', () => {
        setTimeout(() => {
          this.trackPageView();
        }, 100);
      });

      // Override pushState and replaceState to track programmatic navigation
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;

      history.pushState = function(...args) {
        originalPushState.apply(history, args);
        setTimeout(() => {
          analytics.trackPageView();
        }, 100);
      };

      history.replaceState = function(...args) {
        originalReplaceState.apply(history, args);
        setTimeout(() => {
          analytics.trackPageView();
        }, 100);
      };
    }
  }
}

// Create global analytics instance
const analytics = new Analytics();

// Auto-initialize when DOM is ready
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      analytics.init();
    });
  } else {
    analytics.init();
  }
}

export default analytics;
